/*global define */
/*jshint devel:true*/
define(
	'BaseTransferModelCollection',[
		'underscore',
		'backbone',
		'BaseCollection',
		'BaseTransferModel'
	],
	function (_, Backbone, BaseCollection, BaseTransferModel) {
		/**
		 * Base Transfer Model collection
		 * @class BaseTransferModelCollection
		 */
		return BaseCollection.extend(
			/**
			 * @lends BaseTransferModelCollection.prototype
			 */
			{
				className: 'BaseTransferModelCollection',
				model: BaseTransferModel,
				/**
				 * Fetch data for each item of the collection
				 * @see Backbone.Model's fetch(options) method for more info.
				 * @param {Object} options Options to give to the .fetch(options) method.
				 * @param {Object} options.filter Fetch only items that match a given filter (used for the Collection#filter method of Backbone)
				 * @returns {BaseTransferModelCollection}
				 */
				fetchItems: function (options) {
					var self = this,
						args = [].slice.call(arguments),
						items;

					if (options.filter) {
						items = self.where(options.filter);
					} else {
						items = self.models;
					}

					/**
					 * Need to add 'fetch' to our list of arguments before calling Underscore.invoke
					 * @see {@linkplain http://underscorejs.org/#invoke}
					 */
					_.invoke.apply(_, [items, 'fetch'].concat(args));
					return self;
				}
			}
		);
	}
);

